import { z } from 'zod'

/** Where a webhook delivery stands (mirrors Prisma `WebhookDeliveryStatus`). */
export const WEBHOOK_DELIVERY_STATUSES = ['pending', 'delivered', 'failed'] as const

export const webhookDeliveryStatusSchema = z.enum(WEBHOOK_DELIVERY_STATUSES)

export type WebhookDeliveryStatus = z.infer<typeof webhookDeliveryStatusSchema>

export const PRISMA_WEBHOOK_DELIVERY_STATUSES = ['PENDING', 'DELIVERED', 'FAILED'] as const

export type PrismaWebhookDeliveryStatus = (typeof PRISMA_WEBHOOK_DELIVERY_STATUSES)[number]

export const WEBHOOK_DELIVERY_STATUS_FROM_PRISMA = {
  PENDING: 'pending',
  DELIVERED: 'delivered',
  FAILED: 'failed',
} as const satisfies Record<PrismaWebhookDeliveryStatus, WebhookDeliveryStatus>

export const WEBHOOK_DELIVERY_STATUS_TO_PRISMA = {
  pending: 'PENDING',
  delivered: 'DELIVERED',
  failed: 'FAILED',
} as const satisfies Record<WebhookDeliveryStatus, PrismaWebhookDeliveryStatus>
